import React from 'react';
import { GridFilterCellProps } from '@progress/kendo-react-grid';
import { Input } from '@progress/kendo-react-inputs';

const TextFilter: React.FC<GridFilterCellProps> = (props) => {
  const handleChange = (e: any) => {
    props.onChange({
      value: e.target.value,
      operator: 'contains',
      syntheticEvent: e
    });
  };

  return (
    <div className="k-filtercell">
      <Input
        value={props.value || ''}
        onChange={handleChange}
      />
    </div>
  );
};

export default TextFilter;